import { render } from "./DatiPrincipali.vue?vue&type=template&id=067f1aec&scoped=true"
import script from "./DatiPrincipali.vue?vue&type=script&lang=js"
export * from "./DatiPrincipali.vue?vue&type=script&lang=js"

import "./DatiPrincipali.vue?vue&type=style&index=0&id=067f1aec&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067f1aec"]])

export default __exports__